import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full bg-fau-blue-light overflow-auto" }

import loader from "@/views/loader.vue"
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isPageLoaded = ref(false);

function SetPageLoaded(f: boolean) {
  isPageLoaded.value = f;
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(loader, { "is-page-loaded": isPageLoaded.value }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view, { onIsPageLoaded: SetPageLoaded })
      ]),
      _: 1
    }, 8, ["is-page-loaded"])
  ]))
}
}

})